export default "__VITE_PUBLIC_ASSET__eb3392e1__"